(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saaz-banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('saaz-banner-slideshow'))customElements.define('saaz-banner-slideshow',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.cleanups=[];this.slides=[...this.querySelectorAll('[data-slide]')];this.dots=[...this.querySelectorAll('[data-dot]')];this.track=this.querySelector('.ss__track');this.index=0;this.hovered=false;this.focused=false;this.inView=false;this.editorSelected=false;this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.paused=this.dataset.autoplay!=='true'||this.motion.matches;
      this.listen(this.querySelector('[data-next]'),'click',()=>this.go(this.index+1,true));this.listen(this.querySelector('[data-previous]'),'click',()=>this.go(this.index-1,true));this.dots.forEach((dot,i)=>this.listen(dot,'click',()=>this.go(i,true)));
      this.listen(this.querySelector('[data-play]'),'click',()=>{const resume=this.paused;if(resume&&this.dataset.loop!=='true'&&this.index===this.slides.length-1)this.go(0);this.paused=!resume;this.schedule();});
      this.listen(this,'keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1),true);}});
      this.listen(this,'pointerenter',e=>{if(this.dataset.hover==='true'&&e.pointerType!=='touch'){this.hovered=true;this.schedule();}});this.listen(this,'pointerleave',()=>{this.hovered=false;this.schedule();});
      this.listen(this,'focusin',()=>{this.focused=true;this.schedule();});this.listen(this,'focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule();}});
      this.listen(document,'visibilitychange',()=>this.schedule());this.listen(this.motion,'change',()=>{if(this.motion.matches)this.paused=true;this.schedule();});
      this.listen(this,'shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail?.blockId);this.editorSelected=true;if(i>=0)this.go(i);this.schedule();});this.listen(this,'shopify:block:deselect',()=>{this.editorSelected=false;this.schedule();});
      this.listen(this,'pointerdown',e=>{if(this.dataset.swipe==='true'&&e.pointerType==='touch')this.start={x:e.clientX,y:e.clientY};});
      this.listen(this,'pointerup',e=>{if(!this.start)return;const dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;this.start=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)){this.go(this.index+(dx<0?1:-1),true);this.suppressClick=true;clearTimeout(this.clickTimer);this.clickTimer=setTimeout(()=>this.suppressClick=false,350);}});this.listen(this,'pointercancel',()=>this.start=null);
      this.listen(this,'click',e=>{if(this.suppressClick){e.preventDefault();e.stopPropagation();this.suppressClick=false;}},true);
      this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.schedule();},{threshold:.1});this.observer.observe(this);this.go(0);
    }
    listen(target,event,fn,capture=false){if(!target)return;target.addEventListener(event,fn,capture);this.cleanups.push(()=>target.removeEventListener(event,fn,capture));}
    go(next,manual=false){
      if(!this.slides.length)return;const loop=this.dataset.loop==='true';const n=this.slides.length;next=loop?(next+n)%n:Math.max(0,Math.min(n-1,next));this.index=next;
      this.slides.forEach((slide,i)=>{const active=i===next;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;});
      this.track.style.transform=`translateX(-${next*100}%)`;this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===next)));const counter=this.querySelector('[data-counter]');if(counter)counter.textContent=next+1;
      const prev=this.querySelector('[data-previous]'),after=this.querySelector('[data-next]');if(prev)prev.disabled=!loop&&next===0;if(after)after.disabled=!loop&&next===n-1;
      const status=this.querySelector('[data-status]');status.setAttribute('aria-live',manual?'polite':'off');status.textContent=this.slides[next].getAttribute('aria-label');this.schedule();
    }
    schedule(){
      clearTimeout(this.timer);const play=this.querySelector('[data-play]');if(play){play.setAttribute('aria-label',this.paused?this.dataset.playLabel:this.dataset.pauseLabel);this.querySelector('[data-play-icon]').hidden=!this.paused;this.querySelector('[data-pause-icon]').hidden=this.paused;}
      if(this.slides.length<2||this.paused||this.hovered||this.focused||this.editorSelected||!this.inView||document.hidden||getComputedStyle(this).display==='none'||getComputedStyle(this.parentElement).display==='none')return;
      if(this.dataset.loop!=='true'&&this.index===this.slides.length-1){this.paused=true;this.schedule();return;}
      this.timer=setTimeout(()=>this.go(this.index+1),Number(this.dataset.interval)||6000);
    }
    disconnectedCallback(){clearTimeout(this.timer);clearTimeout(this.clickTimer);this.observer?.disconnect();this.cleanups?.forEach(fn=>fn());this.ready=false;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saaz-mobile-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saaz-mobile-video')) {
    customElements.define('saaz-mobile-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized || this.dataset.enabled !== 'true') return;
        this.initialized = true;
        this.mobile = matchMedia('(max-width: 749px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.cleanups = [];
        this.userPaused = false;
        this.inView = false;
        this.controls = this.querySelector('.sv__controls');
        this.on(this.mobile, 'change', () => this.sync());
        this.on(this.motion, 'change', () => this.sync());
        this.on(document, 'visibilitychange', () => this.sync());
        this.on(this.querySelector('[data-play]'), 'click', () => {
          this.ensureVideo();
          if (!this.video) return;
          if (this.video.paused) { this.userPaused = false; this.play(); }
          else { this.userPaused = true; this.video.pause(); }
        });
        this.on(this.querySelector('[data-sound]'), 'click', () => {
          if (!this.video) return;
          this.video.muted = !this.video.muted;
          this.updateControls();
        });
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, {threshold: 0.05});
        this.observer.observe(this);
        this.loader = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && this.mobile.matches) this.ensureVideo();
        }, {rootMargin: '200px'});
        this.loader.observe(this);
        if (this.mobile.matches && this.dataset.load === 'immediate') this.ensureVideo();
      }
      on(target, event, listener) {
        if (!target) return;
        target.addEventListener(event, listener);
        this.cleanups.push(() => target.removeEventListener(event, listener));
      }
      ensureVideo() {
        if (this.video || !this.mobile.matches) return;
        const template = this.querySelector('[data-video-template]');
        if (!template) return;
        this.append(template.content.cloneNode(true));
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = this.dataset.autoplay === 'true' || this.dataset.muted === 'true';
        this.on(this.video, 'play', () => this.updateControls());
        this.on(this.video, 'pause', () => this.updateControls());
        this.on(this.video, 'volumechange', () => this.updateControls());
        this.on(this.video, 'loadedmetadata', () => {
          if (this.video.videoWidth && this.video.videoHeight) this.style.setProperty('--sv-ratio', this.video.videoWidth / this.video.videoHeight);
        });
        this.on(this.video, 'error', () => {
          this.querySelector('.sv__error').hidden = false;
          this.updateControls();
        });
        this.controls.hidden = false;
        this.video.preload = 'metadata';
        this.video.load();
        this.sync();
      }
      sync() {
        if (!this.mobile.matches) { if (this.video) this.video.pause(); return; }
        if (this.inView || this.dataset.load === 'immediate') this.ensureVideo();
        if (!this.video) return;
        const reduced = this.dataset.respectMotion === 'true' && this.motion.matches;
        if (!this.inView || document.hidden || reduced || this.userPaused) { this.video.pause(); return; }
        if (this.dataset.autoplay === 'true') this.play();
      }
      play() {
        if (!this.video || !this.mobile.matches || document.hidden) return;
        this.querySelector('.sv__error').hidden = true;
        this.video.play().catch(() => this.updateControls());
      }
      updateControls() {
        const playing = this.video && !this.video.paused;
        const playButton = this.querySelector('[data-play]');
        if (playButton) {
          playButton.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
          this.querySelector('[data-icon-play]').hidden = playing;
          this.querySelector('[data-icon-pause]').hidden = !playing;
        }
        const soundButton = this.querySelector('[data-sound]');
        if (soundButton && this.video) {
          soundButton.setAttribute('aria-label', this.video.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
          soundButton.setAttribute('aria-pressed', String(!this.video.muted));
          this.querySelector('[data-icon-muted]').toggleAttribute('hidden', !this.video.muted);
          this.querySelector('[data-icon-sound]').toggleAttribute('hidden', this.video.muted);
        }
      }
      disconnectedCallback() {
        if (this.video) { this.video.pause(); this.video.remove(); this.video = null; }
        this.observer?.disconnect(); this.loader?.disconnect();
        this.cleanups?.forEach(fn => fn());
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
